import React, { useEffect, useState } from "react";
import { Button, DatePicker, Form, Input } from "antd";
import "./style.scss";
import logo from "assets/cemlogo.png";
import "./style.scss";
import Swal from "sweetalert2";
import { api } from "services/api";
import { LeftOutlined } from "@ant-design/icons";

export const SignupPage: React.FC = () => {
	const [birthDate, setBirthDate] = useState("");
	const dateFormat = "DD/MM/YYYY";
	const [form] = Form.useForm();
	const handleSignup = (values: any) => {
		api
			.post("/users", values)
			.then((result) => {
				if ([200, 201].includes(result.status)) {
					const {
						data: { feedback },
					} = result;
					Swal.fire({
						icon: "success",
						text: feedback["success"],
						confirmButtonColor: "#63b8cd",
					}).then(() => window.history.back());
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
			})
			.catch((err) => {
				const { status, code } = err;
				if (status === 400 || status === 404 || code === "ERR_NETWORK") {
					Swal.fire({
						icon: "error",
						text: "Desculpe, ocorreu algum problema =( Por favor tente novamente",
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
			});
	};

	useEffect(() => {
		if (document.getElementsByClassName("ant-picker-today-btn")[0]) {
			// eslint-disable-next-line
			// @ts-ignore
			document.getElementsByClassName("ant-picker-today-btn")[0].innerHTML =
				"qwerty";
		}
	}, []);

	return (
		<div className="signup">
			<div className="signup__container">
				<div className="signup__container__header">
					<img src={logo} alt="logo" />
				</div>
				<div className="signup__container__title">
					<button
						className="back"
						onClick={() => window.history.back()}
						style={{ cursor: "pointer" }}
					>
						Voltar
					</button>
					<LeftOutlined
						className="arrow"
						onClick={() => window.history.back()}
					/>

					<h1>Crie sua conta</h1>
				</div>
				<div className="signup__container__form">
					<Form
						name="basic"
						onFinish={(values) => {
							console.log({ values });
						}}
						onFinishFailed={(error) => console.log(error)}
						autoComplete="off"
						form={form}
					>
						<Form.Item
							name={"email"}
							rules={[
								{
									required: true,
									message: "E-mail necessário",
								},
								{
									validator(_, value, callback) {
										if (!value.includes("@")) {
											callback("E-mail inválido");
										}
									},
								},
							]}
						>
							<Input placeholder={"E-mail"} id="userinfo" />
						</Form.Item>
						<Form.Item
							name={"birth_date"}
							rules={[
								{
									required: true,
									message: "E-mail necessário",
								},
							]}
						>
							<DatePicker
								format={dateFormat}
								onClick={() => {
									if (
										document.getElementsByClassName("ant-picker-today-btn")[0]
									) {
										// eslint-disable-next-line
										// @ts-ignore
										document.getElementsByClassName(
											"ant-picker-today-btn"
										)[0].innerHTML = "Hoje";
									}
								}}
								placeholder={"Data de Nascimento"}
								onChange={(_, date) => setBirthDate(date)}
							/>
						</Form.Item>

						<Form.Item
							name="name"
							rules={[
								{
									required: true,
									message: "Nome necessário",
								},
							]}
						>
							<Input placeholder="Nome" id="userinfo2" />
						</Form.Item>

						<Form.Item
							name={"username"}
							rules={[
								{
									required: true,
									message: "Nome do usuário necessário",
								},
							]}
						>
							<Input placeholder={"Username"} id="userinfo3" />
						</Form.Item>

						<Form.Item
							name="password"
							rules={[
								{ required: true, message: "" },
								() => ({
									validator(_, value) {
										if (value.length >= 8) {
											return Promise.resolve();
										}
										return Promise.reject(
											new Error("Digite uma senha com no mínimo 8 caracteres.")
										);
									},
								}),
							]}
						>
							<Input.Password placeholder="Senha" />
						</Form.Item>

						<Form.Item
							name="password_confirmation"
							dependencies={["password"]}
							rules={[
								{ required: true, message: "Senha necessária" },
								({ getFieldValue }) => ({
									validator(_, value) {
										if (!value || getFieldValue("password") === value) {
											return Promise.resolve();
										}
										return Promise.reject(
											new Error(
												"As duas senhas que você digitou não correspondem!"
											)
										);
									},
								}),
							]}
						>
							<Input.Password placeholder="Confirmar senha" />
						</Form.Item>

						<Form.Item>
							<Button
								type="primary"
								htmlType="submit"
								onClick={() => {
									handleSignup({
										email: form.getFieldValue("email"),
										username: form.getFieldValue("username"),
										name: form.getFieldValue("name"),
										password: form.getFieldValue("password"),
										password_confirmation: form.getFieldValue(
											"password_confirmation"
										),
										birth_date: birthDate,
										type_auth: "email",
									});
								}}
							>
								Cadastrar
							</Button>
						</Form.Item>
					</Form>
				</div>
			</div>
		</div>
	);
};
